import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#useProductListing">useProductListing(props)</a> ⇒ <inlineCode><a href="#ProductListingTalonProps">ProductListingTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains logic for a component that renders a list of products for a cart.
It performs effects and returns prop data to render the component on a cart page.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Fetch product listing data associated with the cart`}</li>
          <li parentName="ul">{`Log any GraphQL errors to the console`}</li>
        </ul>
      </dd>
      <dt><a href="#useProduct">useProduct(props)</a> ⇒ <inlineCode><a href="#ProductTalonProps">ProductTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains logic for a product component used in a product listing component.
It performs effects and returns prop data for that component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Manage the updating state of the cart while a product is being updated or removed`}</li>
        </ul>
      </dd>
      <dt><a href="#useEditModal">useEditModal()</a> ⇒ <inlineCode><a href="#EditModalTalonProps">EditModalTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains logic for a product edit modal used on a cart page.
It returns prop data for rendering an interactive modal component.`}</p>
      </dd>
      <dt><a href="#deriveOptionSelectionsFromProduct">deriveOptionSelectionsFromProduct(props)</a> ⇒ <inlineCode><a href="#ProductFormTalonProps">ProductFormTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains logic for a product edit form.
It performs effects and returns data for rendering the component inside a modal container.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Manage the updating state of the cart while form data is being saved`}</li>
          <li parentName="ul">{`Set the variant price on a product depending on the product's options`}</li>
        </ul>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#ProductListingQueries">ProductListingQueries</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL queries for getting product listing data.
This is a type used in the `}<a parentName="p" {...{
            "href": "#useProductListing"
          }}>{`useProductListing`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#ProductListingTalonProps">ProductListingTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "#useProductListing"
          }}>{`useProductListing`}</a>{` talon.
It provides props data for a component that renders a product list.`}</p>
      </dd>
      <dt><a href="#ProductMutations">ProductMutations</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL mutations for a product in a cart.
This is a type used by the `}<a parentName="p" {...{
            "href": "#useProduct"
          }}>{`useProduct`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#ProductTalonProps">ProductTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "#useProduct"
          }}>{`useProduct`}</a>{` talon.
It provides prop data for rendering a product component on a cart page.`}</p>
      </dd>
      <dt><a href="#ProductItem">ProductItem</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Data about a product item in the cart.
This type is used in the `}<a parentName="p" {...{
            "href": "#ProductTalonProps"
          }}>{`ProductTalonProps`}</a>{` type returned by the `}<a parentName="p" {...{
            "href": "#useProduct"
          }}>{`useProduct`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#QuantityTalonProps">QuantityTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "useQuantityStepper"
          }}>{`useQuantityStepper`}</a>{` talon.
It provides props data for a quantity UI component.`}</p>
      </dd>
      <dt><a href="#EditModalTalonProps">EditModalTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "#useEditModal"
          }}>{`useEditModal`}</a>{` talon.
It provides props data for rendering an edit modal component.`}</p>
      </dd>
      <dt><a href="#ProductFormTalonProps">ProductFormTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "useProductForm"
          }}>{`useProductForm`}</a>{` talon.
It provides props data for a product form UI component inside a modal.`}</p>
      </dd>
    </dl>
    <p>{`This talon contains logic for a component that renders a list of products for a cart.
It performs effects and returns prop data to render the component on a cart page.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Fetch product listing data associated with the cart`}</li>
      <li parentName="ul">{`Log any GraphQL errors to the console`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.queries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ProductListingQueries"
            }}><inlineCode parentName="a">{`ProductListingQueries`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL queries for getting product listing data.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useProductListing } from '@magento/peregrine/lib/talons/CartPage/ProductListing/useProductListing';
`}</code></pre>
    <p>{`This talon contains logic for a product component used in a product listing component.
It performs effects and returns prop data for that component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Manage the updating state of the cart while a product is being updated or removed`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ProductItem"
            }}><inlineCode parentName="a">{`ProductItem`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Product item data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.operations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ProductMutations"
            }}><inlineCode parentName="a">{`ProductMutations`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL mutations for a product in a cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setActiveEditItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting the actively editing item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setIsCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting the updating state of the cart`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useProduct } from '@magento/peregrine/lib/talons/CartPage/ProductListing/useProduct';
`}</code></pre>
    <p>{`This talon contains logic for a product edit modal used on a cart page.
It returns prop data for rendering an interactive modal component.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useEditModal } from '@magento/peregrine/lib/talons/CartPage/ProductListing/EditModal/useEditModal';
`}</code></pre>
    <p>{`This talon contains logic for a product edit form.
It performs effects and returns data for rendering the component inside a modal container.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Manage the updating state of the cart while form data is being saved`}</li>
      <li parentName="ul">{`Set the variant price on a product depending on the product's options`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.cartItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The cart item to configure on the form`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.getConfigurableOptionsQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLDocument`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL query to get the configurable options for a product.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setIsCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting the updating state for the shopping cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setVariantPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting the variant price on a product.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.updateConfigurableOptionsMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLDocument`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL mutation for updating the configurable options for a product.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.updateQuantityMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLDocument`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL mutation for updating the quantity of a product in a cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setActiveEditItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting the actively editing item.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useProductForm } from '@magento/peregrine/lib/talons/CartPage/ProductListing/EditModal/useProductForm';
`}</code></pre>
    <p>{`GraphQL queries for getting product listing data.
This is a type used in the `}<a parentName="p" {...{
        "href": "#useProductListing"
      }}>{`useProductListing`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/ProductListing/productListingFragments.js"
      }}>{`productListingFragments.js`}</a>{`
for the queries used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getProductListingQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLDocument`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query to get the product list for a cart`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "#useProductListing"
      }}>{`useProductListing`}</a>{` talon.
It provides props data for a component that renders a product list.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`activeEditItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The product item currently being edited`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isLoading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the query to get the product listing is still in progress. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`error`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Error`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`null`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of graphql errors`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`items`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of products in a cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setActiveEditItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting the current item to edit`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL mutations for a product in a cart.
This is a type used by the `}<a parentName="p" {...{
        "href": "#useProduct"
      }}>{`useProduct`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/ProductListing/product.js"
      }}>{`product.js`}</a>{`
to see the mutations used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`removeItemMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLDocument`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mutation for removing an item in a cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`updateItemQuantityMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLDocument`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mutation for updating the item quantity in a cart`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "#useProduct"
      }}>{`useProduct`}</a>{` talon.
It provides prop data for rendering a product component on a cart page.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errorMessage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Error message from an operation perfored on a cart product.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleEditItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to use for handling when a product is modified.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleRemoveFromCart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to use for handling the removal of a cart product.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleUpdateItemQuantity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to use for handling updates to the product quantity in a cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isEditable`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if a cart product is editable. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ProductItem"
            }}><inlineCode parentName="a">{`ProductItem`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cart product data`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Data about a product item in the cart.
This type is used in the `}<a parentName="p" {...{
        "href": "#ProductTalonProps"
      }}>{`ProductTalonProps`}</a>{` type returned by the `}<a parentName="p" {...{
        "href": "#useProduct"
      }}>{`useProduct`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`currency`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The currency associated with the cart product`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The url for the cart product image`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the product`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of configurable option objects`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`quantity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The quantity associated with the cart product`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`unitPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The product's unit price`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`urlKey`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The product's url key`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`urlSuffix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The product's url suffix`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "useQuantityStepper"
      }}>{`useQuantityStepper`}</a>{` talon.
It provides props data for a quantity UI component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isDecrementDisabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if decrementing should be disabled`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isIncrementDisabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if incrementing should be disabled`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleBlur`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for handling a blur event on a component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleDecrement`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for handling a quantity decrement event`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleIncrement`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for handling an increment event`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`maskInput`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for masking a value when decimal values are allowed`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "#useEditModal"
      }}>{`useEditModal`}</a>{` talon.
It provides props data for rendering an edit modal component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setVariantPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting a product's variant price.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`variantPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The variant price for a product. See `}<a parentName="td" {...{
              "href": "https://devdocs.magento.com/guides/v2.4/graphql/product/product-interface.html#Money"
            }}>{`Money object`}</a>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "useProductForm"
      }}>{`useProductForm`}</a>{` talon.
It provides props data for a product form UI component inside a modal.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`configItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cart item to configure`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errors`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Error>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of form errors resulting from a configuration or quantity value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleOptionSelection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback function handling an option selection event`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleSubmit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback function for handling form submission`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isLoading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the form is loading data. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isSaving`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the form is saving data. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isDialogOpen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the form is visible. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleClose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback function for handling form closing`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`configurableThumbnailSource`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string indicating which thumbnail should be used for configurable products`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/ProductListing/useProductListing.js"
      }}>{`pwa-studio/packages/peregrine/lib/talons/CartPage/ProductListing/useProductListing.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      